<template>
  <span class="app-logo" :class="{ 'app-logo-lg': large }">
    <svg class="app-logo-mark" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient :id="gid" x1="44" y1="4" x2="4" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#22955F" />
          <stop offset="0.55" stop-color="#146C43" />
          <stop offset="1" stop-color="#0B3D2A" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="13" :fill="'url(#' + gid + ')'" />
      <!-- the page of the attendance list -->
      <path d="M15 12.5h13.5" stroke="#FFFFFF" stroke-opacity="0.28" stroke-width="3" stroke-linecap="round" />
      <!-- the check of a present student -->
      <path d="M13.5 25.5l7 7L34.5 17" fill="none" stroke="#FFFFFF" stroke-width="4.6" stroke-linecap="round" stroke-linejoin="round" />
      <!-- «الذكي»: the spark -->
      <circle cx="36.6" cy="12.4" r="3.6" fill="#F2C14E" />
    </svg>
    <span class="app-logo-text" v-if="!markOnly">
      <span class="app-logo-name">التحضير <b>الذكي</b></span>
      <span class="app-logo-sub">{{ sub }}</span>
    </span>
  </span>
</template>

<script>
var n = 0
// The admin's logo: a mark (dark green, a check for attendance, a gold spark for «الذكي») and the
// name in the page's font. Used in the side menu and on the sign-in page.
export default {
  props: {
    sub: { type: String, default: 'لوحة الإدارة' },
    large: { type: Boolean, default: false },
    markOnly: { type: Boolean, default: false },
  },
  data() {
    n++
    return { gid: 'app-logo-g' + n }
  },
}
</script>

<style lang="scss">
.app-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;

  .app-logo-mark {
    width: 42px;
    height: 42px;
    flex: none;
    filter: drop-shadow(0 4px 10px rgba(11, 61, 42, 0.25));
  }

  .app-logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
  }

  .app-logo-name {
    font-size: 1.22rem;
    font-weight: 800;
    color: #12291E;
    white-space: nowrap;
    letter-spacing: -0.2px;

    b {
      font-weight: 800;
      color: #146C43;
    }
  }

  .app-logo-sub {
    font-size: 0.72rem;
    color: #6B7A72;
    font-weight: 500;
    letter-spacing: 0.4px;
  }

  &.app-logo-lg {
    gap: 14px;
    .app-logo-mark { width: 64px; height: 64px; }
    .app-logo-name { font-size: 1.8rem; }
    .app-logo-sub { font-size: 0.9rem; }
  }
}
</style>
